import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import { useEffect } from "react";
import NavDistricts from "./NavDistricts";
import NavCampaign from "./NavCampaign";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div className="morkBorgFont morkBorgTitleText">
        <p align="center">
          <NavDistricts />

          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-the-docks.webp"
            alt="The Docks"
          />
        </p>
        <strong>
          Rough taverns, tattoo parlors, fighting pits, and warehouses.
        </strong>{" "}
        <em>
          The docks of Doskvol are <strong>ancient</strong>, going back to the
          days before the cataclysm, when the area{" "}
          <strong>was a colony town of the old Skov kingdom</strong>. Today,
          some commerce has shifted to the new electro-rail lines of the
          Imperium, but the docks are still bustling with{" "}
          <strong>cargo haulers</strong>, <strong>fishing boats</strong>, and
          the prestigious <strong>leviathan hunter ships</strong> that provide
          the raw material that keeps the city running.
        </em>
        <img
          src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-the-docks.webp"
          alt="The Docks"
        />
        <table className="district-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>District Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign="top">
                <strong>Scene:</strong> Small and medium steamships docked
                close, dwarfed by the titanic leviathan hunter ships further
                out. Throngs of sailors and dockers, doing their work, singing
                work-songs. Heavy cargo rumbling away on wagons. Shouts and
                breaking glass from a brawl spilling out of a tavern.
                <br />
                <strong>Streets:</strong> Raised streets perched over the docks
                themselves, rigged with cranes and winches.
                <br />
                <em>
                  North Hook Way, Carter Street, Plume Street, Saltford Street,
                  Ink Lane.
                </em>
                <br />
                <strong>Buildings:</strong> Massive cargo warehouses. Squat
                taverns, brothels, and tattoo parlors. Crowded overnight
                bunkhouses for sailors.
                <br />
                <strong>Factions:</strong>
                <ul>
                  <li>1. The Gray Cloaks</li>
                  <li>2. The Fog Hounds</li>
                  <li>3. The Dockers</li>
                  <li>4. The Billhooks</li>
                  <li>5. The Crows</li>
                  <li>6. The Grinders</li>
                  <li>7. Red Sashes</li>
                  <li>8. Imperial Military</li>
                  <li>9. Leviathan Hunters</li>
                </ul>
              </td>
              <td valign="top">
                <img
                  src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-traits-the-docks.webp"
                  alt="The Docks district traits"
                />
                <br />
                <em>
                  Operations against ships at port are considered on “hostile
                  turf” for the purpose of generating <strong>heat</strong>.
                </em>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1>Docks Locations</h1>
        <strong>
          <u>Ink Lane</u>
        </strong>
        : This twisting back-street is home to many of the city’s tattooists as
        well as several newspapers—who all share the cost of their inks in bulk.
        A fine place for gossip and rumors of all kinds.
        <br />
        <br />
        <strong>
          <u>The Menagerie</u>
        </strong>
        : A fenced-off muddy field, dotted with rusting animal pens, water
        tanks, and gaudy signage. Sailors traditionally drop off any curious
        creatures they pick up in their travels, which Captain Rye, the strange
        proprietor, incorporates into his makeshift zoological displays.
        <br />
        <br />
        <strong>
          <u>The North Hook Company</u>
        </strong>
        : This grand, old-fashioned estate house is headquarters for the oldest
        surviving shipping and naval exploration enterprise in the Imperium. The
        North Hook Company has a massive fleet of trade ships and is considered
        by many to be merely a private front for the Ministry of Preservation.
        No one knows for sure, since enemies and rivals of the company, not to
        mention overly curious journalists, tend to disappear.
        <br />
        <br />
        <strong>
          <u>Saltford&apos;s</u>
        </strong>
        : A squat stone building that houses one of the more notorious private
        banks in Duskwall. Being so close to the docks, Saltford’s has faced
        many gangs of whiskey’d sailors that decided to turn to robbery as a new
        line of work, and defeated them all—sometimes even hanging the corpses
        from their lamp-posts as discouragement to the next pack of drunken
        fools.
        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClasses_Districts_Docks = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <img
                  src={bladesLogo}
                  style={{ maxWidth: "200px" }}
                  alt="Blades in the Dark campaign"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <NavCampaign />
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <a name="pageTop" href="#pageTop">
                {" "}
              </a>
              <img
                src={sectionDivider}
                className="BITD-section-divider"
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClasses_Districts_Docks;
